<template>
  <div :endpoint='api.$.evedpaycard.transactions'>
    <slot name='title' />
    <div class='no-data' v-if='transactions && !transactions.length'>
      <div>
        <i class='icon fas fa-list'></i>
        <h3>No Transactions</h3>
        <p>Your transactions will appear here</p>
      </div>
    </div>
    <div v-for='(transaction, i) in transactions' @click="() => redirectTransaction(transaction)">
      <h6 v-if='showHeader(transaction, i)'>
        {{ headerText(transaction) }}
      </h6>
      <ed-notice class='transaction' :type='transactionStatusColor(transaction.status, transaction.reconcileStatus)'>
        <p><strong>EvedPay Card ... {{ transaction.cardNumber }}</strong></p>
        <div class="col-xs-9" style="padding:0">
          <p class="merchant"><strong>{{ transaction.merchant }}</strong></p>
        </div>
        <div class="col-xs-3 text-right">
          <p class="amount"><strong><v-money>{{ transaction.amount }}</v-money></strong></p>
        </div>
        <div class="col-xs-9" style="padding:0" v-if="transaction.status === 'Pending'">
          <p class="date">{{ showDate(transaction) }} | Pending</p>
        </div>
        <div class="col-xs-9" style="padding:0" v-else>
          <p class="date">{{ showDate(transaction) }}</p>
        </div>
        <div class="col-xs-3 text-right" style="padding-right:15px">
          <i v-if="transaction.receipt !== null" class="fas fa-camera" style="color: #4A90E2;"></i>
        </div>
      </ed-notice>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/event-bus'
export default {
  alias: 'evedpaytransactions',
  data() {
    return {
      transactions: null,
      dateFormat: null
    }
  },
  computed: {
    moment() { return global.moment }
  },
  created() {
    this.getTransactions()
    EventBus.$off('transaction-reconciled')
    EventBus.$on('transaction-reconciled', (transactionId) => {
      const matchedTransaction = this.transactions.find(transaction => transaction.Id === transactionId.data)
      if (matchedTransaction) {
        const matchedId = matchedTransaction.Id
        const token = this.$route.query.token
        this.$notifications.notify({
          message: `Transaction was updated!<a href="#/evedpay/transactiondetails?token=${token}&transactionid=${matchedId}"> Tap to revisit.</a>`,
          type: 'info',
          placement: { from: 'top', align: 'center' }
        })
      }
    })
  },
  methods: {
    async getTransactions() {
      try {
        const response = await this.api.forms.post(this.api.$.evedpaycard.transactions, {
          sort: 'TransactionGroup',
          dir: 'DESC',
          start: 0,
          limit: 1000,
          isLiveGrid: true,
          filter: JSON.stringify({
            searchTerm: ''
          })
        })
        this.transactions = response.data.Data.map(transaction => ({
          ...transaction,
          merchant: transaction.Merchant,
          amount: transaction.Amount,
          date: transaction.TransactionDate,
          status: transaction.TransactionStatus,
          id: transaction.Id,
          cardNumber: transaction.CardNumber,
          reconcileStatus: transaction.ReconciliationStatus,
          receipt: transaction.Receipt
        }))
      } catch (error) {
        console.error('Error fetching transactions:', error)
      }
    },
    showDate(transaction) {
      this.dateFormat = this.$user &&
        this.$user.sessionSettings &&
        this.$user.sessionSettings.DateAndTimeFormats &&
        this.$user.sessionSettings.DateAndTimeFormats.MomentDateFormat
        ? this.$user.sessionSettings.DateAndTimeFormats.MomentDateFormat
        : 'MM-DD-YYYY'
      const date = this.moment(transaction.date).format(this.dateFormat)

      return date
    },
    hasAccountPermission(permission) {
      if (this.$user && this.$user.$.userPermissions) {
        return this.$user.$.userPermissions.includes(permission)
      }

      return false
    },
    transactionStatusColor(status, reconcileStatus) {
      if ((status === 'In Envelope' && reconcileStatus === 'Approved') || (['Exported', 'Posted'].includes(status) && ['Coded', 'Approved'].includes(reconcileStatus))) {
        return 'alt'
      } else if (['Open', 'Returned', 'In Envelope'].includes(status) && reconcileStatus === 'Open') {
        return 'warn'
      } else if (status === 'Declined') {
        return 'danger'
      } else if (status === 'Pending' && reconcileStatus === 'Open') {
        return 'info'
      } else if (['Open', 'Returned', 'In Envelope', 'Pending'].includes(status) && reconcileStatus === 'Coded') {
        return 'alt'
      } else {
        return 'info'
      }
    },
    headerText(transaction) {
      const status = transaction.status
      const reconcileStatus = transaction.reconcileStatus

      if ((status === 'In Envelope' && reconcileStatus === 'Approved') || (['Exported', 'Posted'].includes(status) && ['Coded', 'Approved'].includes(reconcileStatus))) {
        return 'Completed'
      } else if (['Open', 'Returned', 'In Envelope', 'Pending'].includes(status) && reconcileStatus === 'Open') {
        return 'Open'
      } else if (status === 'Declined') {
        return 'Declined'
      } else if (['Open', 'Returned', 'In Envelope', 'Pending'].includes(status) && reconcileStatus === 'Coded') {
        return 'Coded'
      } else {
        return `${status} - ${reconcileStatus}`
      }
    },
    showHeader(transaction, index) {
      if (index === 0) return true

      const previousTransaction = this.transactions[index - 1]
      return this.headerText(transaction) !== this.headerText(previousTransaction)
    },
    redirectTransaction(transaction) {
      this.$router.push({
        path: '/evedpay/transactiondetails',
        query: {
          ...this.$route.query,
          transactionid: transaction.id
        }
      })
    }
  }
}

</script>

<style lang='scss' scoped>
@import "~@/assets/sass/_variables.scss";

.no-data {
  height: calc(100vh - 15em);
  width: 75%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  h3 {
    margin-top: 1.6em;
    margin-bottom: 0.2em;
    font-weight: 600;
  }
  h3, p, .icon {
    color: #4e2683;
  }
  p {
    line-height: 1.2em;
  }

  .icon {
    font-size: 5em;
    &:after {
      position: absolute;
      display: block;
      content: '';
      left: 50%;
      top: 50%;
      margin-top: -80px;
      margin-left: -80px;
      width: 160px;
      height: 160px;
      border-radius: 50%;
      background: rgba(78,38,131,0.15);
      z-index: -1;
    }
  }
}

.transaction {
  border-radius: 6px;
  border-top-width: 0px !important;
  border-right-width: 0px !important;
  border-bottom-width: 0px !important;
  box-shadow: 1px 3px 5px 0px rgba(0,0,0,0.15);
  >>> &.no-icon .icon-wrapper.no-icon {
    min-width: 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/_modules/EvedPay/transactions.vue